import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Result, Button } from 'antd';

const ProtectedRoute = ({ children, requiredPermission, requiredModule }) => {
  const { currentUser, hasPermission, canAccessModule, loading } = useAuth();
  const location = useLocation();

  // Check if still loading auth state
  if (loading) {
    return <div>Loading...</div>;
  }

  // Not logged in - redirect to login page
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check module access
  if (requiredModule && !canAccessModule(requiredModule)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you don't have access to this page."
        extra={
          <Button 
            type="primary" 
            onClick={() => window.history.back()}
            style={{
              background: '#394A3F',
              borderColor: '#394A3F',
              borderRadius: 0,
            }}
          >
            Go Back
          </Button>
        }
      />
    );
  }

  // Check specific permission
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you don't have the required permissions for this action."
        extra={
          <Button 
            type="primary" 
            onClick={() => window.history.back()}
            style={{
              background: '#394A3F',
              borderColor: '#394A3F',
              borderRadius: 0,
            }}
          >
            Go Back
          </Button>
        }
      />
    );
  }

  // All checks passed, render children
  return children;
};

export default ProtectedRoute;